import React, { useRef, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import SignIn from "./components/SignIn";
import app from "./components/firebase";
import HomePage from "./components/HomePage";
import logoTitle from "./assets/logo4.png"; 

// Router
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import GeneradorDocumentos from "./components/GeneradorDocumentos";
import LectorCedulas from "./components/LectorCedulas";
import Afp from "./components/Afp";
import AsistenciaLibro from "./components/asistencia-libro";
import RegistrosDT from "./components/registros-dt";
import AsistenciaVoucher from "./components/asistencia-voucher";
import DocumentosTrabajadores from "./components/Documentos_Trabajadores";
import { AuthProvider } from './components/AuthContext';
import SpliterDocumental from "./components/SpliterDocumental";

import "./style/App.css";

// RequireAuth
function RequireAuth({ children, user }) {
  let location = useLocation();

  if (!user) {
    // Usuario no está autenticado, redirigir a la página de inicio de sesión
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children; // Usuario está autenticado, permitir acceso a la ruta
}

function App() {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const auth = getAuth(app);
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // Usuario está conectado
        setCurrentUser(user);
      } else {
        // Usuario no está conectado
        setCurrentUser(null);
      }
    });
  }, []);

  return (
    <AuthProvider>
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <div className="signInContainer">
                  {currentUser ? (
                    <HomePage currentUser={currentUser} />
                  ) : (
                    <>
                      <p></p>
                      <img src={logoTitle} alt="Logo" className="logo-title" />
                      <SignIn />
                    </>
                  )}
                </div>
              </>
            }
          />
          <Route
            path="/generador-documentos"
            element={
              <RequireAuth user={currentUser}>
                <GeneradorDocumentos />
              </RequireAuth>
            }
          />
          <Route
            path="/lector-cedulas"
            element={
              <RequireAuth user={currentUser}>
                <LectorCedulas />
              </RequireAuth>
            }
          />
          <Route
            path="/asistencia-voucher"
            element={
              <RequireAuth user={currentUser}>
                <AsistenciaVoucher />
              </RequireAuth>
            }
          />
          <Route
            path="/asistencia-libro"
            element={
              <RequireAuth user={currentUser}>
                <AsistenciaLibro />
              </RequireAuth>
            }
          />
          <Route
            path="/registros-dt"
            element={
              <RequireAuth user={currentUser}>
                <RegistrosDT />
              </RequireAuth>
            }
          />
          <Route
            path="/afp"
            element={
              <RequireAuth user={currentUser}>
                <Afp />
              </RequireAuth>
            }
          />
          <Route
            path="/documentos-trabajadores"
            element={
              <RequireAuth user={currentUser}>
                <DocumentosTrabajadores />
              </RequireAuth>
            }
          />
          <Route
            path="/home"
            element={
              <RequireAuth user={currentUser}>
                <HomePage />
              </RequireAuth>
            }
          />
          <Route
            path="/splitter-documental"
            element={
              <RequireAuth user={currentUser}>
                <SpliterDocumental />
              </RequireAuth>
            }
          />
        </Routes>
      </div>
    </Router>
    </AuthProvider>
  );
}

export default App;
